
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, April 23, 2018
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedurgencypreferences",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	setPreferences: setPreferences,
	trackChanges: trackChanges,
	refresh: refresh,
	_who: null
});

function init() {
	this._tracker = this.dispatcher.createTracker();
	this.push(null);
}

function uninit(){
	this._tracker.off();
	this._tracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"managedaccount:updated": handle_managedaccount_update,
	};
}

function triggers(){
	return {
		"update": updatePreferences
	};
}

function refresh(){
	if(!this._who) return;
	this.api.manage.urgency.preferences.get(this._who, this._group)
		.then(setPreferences.bind(this))
		.then(trackChanges.bind(this));
}

function setPreferences(data) {
	this.push(data);
}

function handle_managedaccount_update(data){
	var who = data.data._id;
	const group = data.group;
	if(this._who === who) return;
	this._who = who;
	this._group = group;
	this.refresh();
}

function trackChanges(){
	var tracker = this._tracker;
	var who = this._who;
	var group = this._group;
	if(!who || !tracker) return;
	tracker.off();
	if(group)
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/urgency/preferences/updated", setPreferences.bind(this));
	else
		tracker.on("mqtt:u/" + who + "/urgency/preferences/updated", setPreferences.bind(this));
}

function updatePreferences(data){
	var who = this._who;
	if(!who) return;
	const group = this._group;
	this.emit("usermetrics:trigger:track", "update managed urgency preferences", {
		who,
	});
	return this.api.manage.urgency.preferences.update(who, data, group).then(() => {
		this.dispatch("newurgencypreferences", {
			who: this._who,
			section: "urgencycontacts",
			timestamp: new Date().toISOString(),
		});
	});
}
